import React from "react"
import ReactDom from "react-dom"

import App from "./src/containers/App"
import "./src/css/index.scss"

ReactDom.render(
    <App />,
    document.getElementById("root")
)